import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "react-bootstrap-typeahead/css/Typeahead.css";
import trasportApi from "../../api/trasportApi";
import PubSub from 'pubsub-js';
const SubjectEdit = (props) => {

  const [validated, setValidated] = useState(false);
  const [isItem, setItem] = useState(props ? props.itemRec : {});
 
  const checkRequiredFields = () => {
    if (
      isItem.name &&
      isItem.name.trim() !== "" &&
      isItem.price_deduction &&
      isItem.price_deduction.trim() !== "" 
    ) {
     
      return false;
    }
    return true;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
   

    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }
    let result2 = {};

    if (isItem.id) {
      result2 = await trasportApi.saveItem(isItem);
      if (result2.success) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record Updated successfully' });
      }
    } else {
      console.log("Create Time Item =>",isItem)
      result2 = await trasportApi.createItem(isItem);
      if (result2?.id) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record saved successfully' });
      } else {
        //submitDoctorDuties();
        //PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record ERROR', message: result2.errors[0].msg });
      }
    }

  };

  const handleItem  = async (e) => {
    setItem({ ...isItem, [e.target.name]: e.target.value });
  };

  return (
    <Modal {...props} size="lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Item
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="view-form">
          <Row>
            <Col lg={12}>
              <Form
                className="mt-3"
                onSubmit={handleSubmit}
                controlId="subjectCreate"
                noValidate validated={validated}
              >
                <Row>
                <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Item Name
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="name"
                        placeholder="Enter Item Name"
                        value={isItem.name}
                        onChange={handleItem}
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Item Price Deduction
                      </Form.Label>
                      <Form.Control
                        required
                        type="number"
                        name="price_deduction"
                        placeholder="Enter Item head"
                        value={isItem.price_deduction}
                        onChange={handleItem }
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                      Deduction Weight
                      </Form.Label>
                      <Form.Control
                        type="email"
                        name="deduction_weight"
                        placeholder="Enter Item Deduction Weight"
                        value={isItem.deduction_weight}
                        onChange={handleItem}
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide} variant="light">
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal >
  );
};
export default SubjectEdit;
